import * as React from 'react'

import router from 'next/router'

import TabsSections from 'components/shared/tabs-sections'
import TitlePage from 'components/shared/title-page'

import useTranslation from 'next-translate/useTranslation'
import CreditResume from 'components/shared/credit-resume'
import ProgressBox from 'components/theory/components/progress-box'

interface TabProps {
    children: JSX.Element
    tabs: string[]
    tabFromPath: string
    section: 'sim' | 'quiz' | 'challenge' | 'settings' | 'simConcluded' | 'theory'
    indexTab: number
    setIndexTab: (value: number) => void
}

const TabsLayout = React.memo<TabProps>(({ children, indexTab, tabs, setIndexTab, section, tabFromPath }) => {
    const path = React.useMemo(() => router.pathname.split('/'), [])
    const { t } = useTranslation('header')

    return (
        <div className="w-full">
            <div>
                <div className="flex justify-between flex-col lg:flex-row pt-2 sm:pt-6 px-3 sm:px-12">
                    <div style={{ flex: 0.9 }} className="min-h-[100px]">
                        <TitlePage
                            title={t(`${section}.${tabs[indexTab]}.title`)}
                            subtitle={t(`${section}.${tabs[indexTab]}.description`)}
                        />
                    </div>
                    {section !== 'theory' && <CreditResume path={path[1]} />}
                    {section === 'theory' && (
                        <div className="w-8/12 lg:w-4/12">
                            <ProgressBox />
                        </div>
                    )}
                </div>

                <TabsSections
                    tabFromPath={tabFromPath}
                    section={section}
                    tabs={tabs}
                    indexTab={indexTab}
                    setIndexTab={setIndexTab}
                />
            </div>

            <div className="px-3 sm:px-12 pb-4">{children}</div>
        </div>
    )
})

export default TabsLayout
